import { FC, useRef } from "react";
import { Flex, useDisclosure } from "@chakra-ui/react";
import {
  DrawerContent,
  setMobileDrawerContent,
} from "~/features/MobileDrawerContent";
import { useAppDispatch } from "~/store/hooks";
import { Logo } from "./Logo";
import { MobileDivider } from "./MobileDivider";
import { MobileHeaderDrawer } from "./MobileHeaderDrawer";
import { MobileHeaderIcon } from "./MobileHeaderIcon";
import { useNavItems } from "./useNavItems";

export const MobileHeader: FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = useRef() as any;
  const { leftNavItems, rightNavItems } = useNavItems();
  const dispatch = useAppDispatch();

  const handleClick =
    (fn?: () => void, drawerContent?: DrawerContent) => () => {
      fn?.();
      if (!drawerContent) {
        onClose();
      } else {
        dispatch(setMobileDrawerContent(drawerContent));
      }
    };

  return (
    <>
      <Logo monitor="mobile" />
      <MobileHeaderIcon btnRef={btnRef} onOpen={onOpen} />

      <MobileHeaderDrawer
        btnRef={btnRef}
        isOpen={isOpen}
        onClose={onClose}
        onCloseComplete={() => dispatch(setMobileDrawerContent("default"))}
      >
        <Flex direction="column" gap={5}>
          {leftNavItems.map(({ Component, onClick, ...props }, index) => {
            return (
              <Component
                key={index}
                onClick={handleClick(onClick)}
                {...props}
              />
            );
          })}
        </Flex>

        {!!leftNavItems.length && <MobileDivider my={6} />}

        <Flex direction="column" gap={5}>
          {rightNavItems.map(
            ({ Component, onClick, drawerContent, ...props }, index) => (
              <Component
                key={index}
                drawerContent={drawerContent}
                onClick={handleClick(onClick, drawerContent)}
                {...props}
              />
            ),
          )}
        </Flex>
      </MobileHeaderDrawer>
    </>
  );
};
